import { render } from "./DetailText.vue?vue&type=template&id=33e1f55e&scoped=true"
import script from "./DetailText.vue?vue&type=script&lang=js"
export * from "./DetailText.vue?vue&type=script&lang=js"

import "./DetailText.vue?vue&type=style&index=0&id=33e1f55e&lang=scss&scoped=true"
import "./DetailText.vue?vue&type=style&index=1&id=33e1f55e&lang=scss"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e1f55e"]])

export default __exports__